import { memo } from 'react';
import { SettingsButton } from './SettingsButton';
import { defaultRenderButton } from './defaultRenderButton';
import { settingsGroup, settingsGroupLabel, settingsGroupButtons } from './classNames';
import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";

function SettingsGroupInner(_ref) {
  var _ref$group = _ref.group,
      label = _ref$group.label,
      property = _ref$group.property,
      options = _ref$group.options,
      renderButton = _ref$group.renderButton,
      value = _ref.value,
      setValue = _ref.setValue;
  return /*#__PURE__*/_jsxs("div", {
    className: settingsGroup,
    children: [/*#__PURE__*/_jsxs("div", {
      className: settingsGroupLabel,
      children: [label, ":"]
    }), /*#__PURE__*/_jsx("div", {
      className: settingsGroupButtons,
      children: options.map(function (option) {
        return /*#__PURE__*/_jsx(SettingsButton, {
          property: property,
          option: option,
          value: value,
          setValue: setValue,
          children: renderButton || defaultRenderButton
        }, option.value);
      })
    })]
  });
}

export var SettingsGroup = /*#__PURE__*/memo(SettingsGroupInner);